import React, { useEffect } from 'react';
import { useFormContext } from '../FormContext';
import { FormStep } from '../FormStep';
import { FormButtons } from '../FormButtons';
import { Check } from 'lucide-react';
export const RoofMaterialStep: React.FC = () => {
  const {
    formData,
    handleOptionSelect,
    goToPreviousStep,
    goToNextStep
  } = useFormContext();
  // Determine the project type for display text
  const projectType = formData.projectTypes.includes('veranda') ? 'veranda' : formData.projectTypes.includes('overkapping') ? 'overkapping' : 'tuinkamer';
  // Set default selection if none is selected
  useEffect(() => {
    if (!formData.roofMaterial) {
      handleOptionSelect('roofMaterial', 'glas-helder');
    }
  }, [formData.roofMaterial, handleOptionSelect]);
  const roofOptions = [{
    id: 'glas-helder',
    name: 'Glas helder',
    description: 'Volledig transparant, maximale lichtinval',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/bRHkJpmrhxY8eKDPaMTsVp/Glas_Helder.jpg'
  }, {
    id: 'glas-opaal',
    name: 'Glas opaal',
    description: 'Diffuus licht, elegante uitstraling',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/mTphfuDJUHEWQr328phJUp/Glas_Opaal.jpg'
  }, {
    id: 'polycarbonaat-opaal',
    name: 'Polycarbonaat opaal',
    description: 'Diffuus licht, minder warmte-doorlating',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/qfeoKrdCtds3nU26Adxu2f/Poly_Opaal.jpg'
  }, {
    id: 'polycarbonaat-helder',
    name: 'Polycarbonaat helder',
    description: 'Lichtgewicht, voordelig en UV-bestendig',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/3oKBkyvCiuE1eYBz2RSs5s/Poly_Helder.jpg'
  }];
  // Find the selected option
  const selectedOption = roofOptions.find(option => option.id === formData.roofMaterial);
  return <FormStep title={`Welke dakbedekking wenst u voor uw ${projectType}?`} description={`Kies het type dakbedekking voor uw ${projectType}.`} isActive={true} data-id="element-1100">
      {/* Wider layout with more space for the content */}
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-4 lg:gap-8 mb-10" data-id="element-1101">
        {/* Preview Image - Takes more space on desktop */}
        <div className="lg:col-span-8 bg-white/5 rounded-lg overflow-hidden" data-id="element-1102">
          {selectedOption && <div className="flex flex-col h-full" data-id="element-1103">
              <div className="relative w-full h-[300px] md:h-[350px] overflow-hidden" data-id="element-1104">
                <img src={selectedOption.image} alt={selectedOption.name} className="w-full h-full object-cover" data-id="element-1105" />
                <div className="absolute top-4 right-4 bg-[#CDA735] text-white px-3 py-1 rounded-md text-sm font-medium" data-id="element-1106">
                  Geselecteerd
                </div>
              </div>
              <div className="p-4 bg-white/10 backdrop-blur-sm" data-id="element-1107">
                <h3 className="text-xl font-semibold text-white mb-1" data-id="element-1108">
                  {selectedOption.name}
                </h3>
                <p className="text-white/80" data-id="element-1109">{selectedOption.description}</p>
              </div>
            </div>}
        </div>
        {/* Options - Vertical list of choices with improved mobile layout */}
        <div className="lg:col-span-4 space-y-3" data-id="element-1110">
          <h3 className="text-lg font-medium text-white/90 mb-3" data-id="element-1111">
            Kies uw dakbedekking voor uw {projectType}:
          </h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-1 gap-3" data-id="element-1112">
            {roofOptions.map(option => <div key={option.id} onClick={() => handleOptionSelect('roofMaterial', option.id)} className={`p-3 rounded-lg cursor-pointer transition-all duration-300 flex items-center gap-3 ${formData.roofMaterial === option.id ? 'bg-[#CDA735] text-white' : 'bg-white/10 text-white hover:bg-white/20'}`} data-id="element-1113">
                {/* Fixed height for thumbnails to prevent layout shifts */}
                <div className="w-16 h-16 flex-shrink-0 rounded-md overflow-hidden" data-id="element-1114">
                  <img src={option.image} alt={option.name} className="w-full h-full object-cover" data-id="element-1115" />
                </div>
                <div className="flex-grow min-w-0" data-id="element-1116">
                  <h4 className="font-medium truncate" data-id="element-1117">{option.name}</h4>
                  <p className="text-sm opacity-80 line-clamp-1" data-id="element-1118">
                    {option.description}
                  </p>
                </div>
                {formData.roofMaterial === option.id && <div className="w-6 h-6 rounded-full bg-white flex items-center justify-center flex-shrink-0" data-id="element-1119">
                    <Check className="h-4 w-4 text-[#CDA735]" data-id="element-1120" />
                  </div>}
              </div>)}
          </div>
          {/* Mobile-friendly instruction */}
          <p className="text-sm text-white/60 mt-4 lg:hidden" data-id="element-1121">
            Tik op een optie om deze te selecteren en de details te bekijken.
          </p>
        </div>
      </div>
      <FormButtons onPrevious={goToPreviousStep} onNext={goToNextStep} isNextDisabled={!formData.roofMaterial} data-id="element-1122" />
    </FormStep>;
};